import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MousePointerClick, Image, Send, Search, BarChart3, ShoppingBag, Filter, Type, Settings, DollarSign, Mail } from 'lucide-react';

const steps = [
    {
        title: 'MIP Power Search - Find Best CC Campaigns',
        icon: Search,
        items: [
            { icon: Filter, label: 'Set Filters', image: '/ccpage.png' },
            { icon: MousePointerClick, label: 'Click on "Run MIP Power Search"' },
            { icon: Type, label: 'Choose keyword (category / item / etc.)', image: '/powersearch1.png' },
            { icon: Send, label: 'Click launch and wait for the results!', image: '/powersearch2.png' },
        ],
    },
    {
        title: 'Find Campaigns for My Videos',
        icon: DollarSign,
        items: [
            { icon: Filter, label: 'Click on "Find Campaigns for My Videos"', image: '/ccpage.png' },
            { icon: Settings, label: 'Make sure you have set your storefront URL and waited for it to finish syncing!' },
            { icon: Image, label: 'You will see a list of all campaigns you have videos for - make sure to accept and link!' },
        ],
    },
    {
        title: 'MIP Message System',
        icon: Mail,
        items: [
            { icon: MousePointerClick, label: 'Click the "MIP Send Message" button.' },
            { icon: MousePointerClick, label: 'Click "Send Message with MIP"', image: '/mipmsg.png' },
            { icon: Send, label: 'Go to "Manage Templates" to create a template and send it later from the "Use Template" tab. Use variables to automatically apply info!', image: '/ccmsgs.jpg' },
        ],
    },
];

const CreatorConnectionsPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-10 px-4">
            <div className="max-w-2xl mx-auto">

                {/* Header */}
                <div className="mb-8 text-center">
                    <h1 className="text-3xl font-bold text-gray-800 mb-2">Creator Connections</h1>
                    <h2 className="text-1xl font-bold text-gray-800 mb-2">Make sure to download our Chrome Extension - this is how all the features are loaded!</h2>
                    <p className="text-gray-500 text-sm">A quick guide to each feature</p>
                </div>

                {/* Steps */}
                <div className="space-y-6">
                    {steps.map(({ letter, title, icon: Icon, items, image }) => (
                        <div key={letter} className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">

                            {/* Card header */}
                            <div className="flex items-center gap-4 px-6 py-4 border-b border-gray-100">
                                <div className="flex items-center gap-2">
                                    <Icon size={18} className="text-blue-600" />
                                    <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
                                </div>
                            </div>

                            {/* Steps list */}
                            <ul className="divide-y divide-gray-50">
                                {items.map(({ icon: StepIcon, label, image }, idx) => (
                                    <li key={idx} className="flex flex-col items-start gap-4 px-6 py-4">
                                        <div className='flex flex-row gap-2'>
                                            <span className="w-6 h-6 rounded-full bg-blue-50 text-blue-600 text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                                                {idx + 1}
                                            </span>
                                            <StepIcon size={16} className="text-gray-400 flex-shrink-0 mt-1" />
                                            <span className="text-gray-700 text-sm leading-relaxed">{label}</span>
                                        </div>
                                        {image && <div className="px-6 pb-2 border rounded-xl">
                                            <img src={image} />
                                        </div>}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Back button */}
                <div className="mt-8 text-center">
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="px-6 py-2 text-sm font-semibold text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-50 transition"
                    >
                        ← Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreatorConnectionsPage;